import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class AccountsModule {}
export { AccountsApiService } from './services/accounts-api.service';
export { Account } from './types/account';
export { AccountResponse } from './types/account-response';
